"use client";

import { Header } from "@/components/layout/header";
import { HideOnWorkspace } from "@/components/layout/hide-on-workspace";

/**
 * Thin client wrapper so the marketing layout can stay a server component.
 *
 * The Header owns its own mobile menu state (the hamburger overlay). The
 * persistent bottom tab bar was removed: it duplicated the header menu,
 * surfaced off-message individual links, and overlapped the footer on mobile.
 *
 * Hidden on the full-screen course workspace (which has its own top bar).
 */
export function NavigationShell() {
  return (
    <HideOnWorkspace>
      <Header />
    </HideOnWorkspace>
  );
}
